<script lang="ts" setup>
import { LoaderBlockDomain } from '@UI/Loaders/LoaderBlockDomain'

defineOptions({
  name: 'SkeletonAllLessons',
})

</script>

<template>
  <div class="skeleton-all-lessons">
    <LoaderBlockDomain />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Skeletons/Paid/AllLessons/SkeletonAllLessons.scss" />
